import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DataService {
  private _suppliers: ISupplier[];
  supplier$ = new BehaviorSubject<ISupplier | undefined>(undefined);
  suppliers: ISupplier[];
  constructor(private http: HttpClient) { }

  set supplier(supplier: ISupplier | undefined) {
    this.supplier$.next(supplier);
  }

  async getSuppliers() {
    this.suppliers = this.getSessionData('suppliers');
    if (!this.suppliers.length) {
      const response = await lastValueFrom(this.http.get<{ status: string; docs?: ISupplier[]; error?: any; }>(environment.baseUrl + '/suppliers'));
      this.suppliers = response.docs || [];
      this.setSessionData('suppliers', this.suppliers);
    }
    return this.suppliers;
  }

  async getProducts(supplier: ISupplier | undefined) {
    // match product to supplier by VendorId
    let products: IProduct[] = [];
    if (supplier?.vendors.length) {
      const vendorNos = supplier.vendors.map(v => v.number); // it is called 'number' in the collection even though it is an alphanumeric string
      try {
        const response = await lastValueFrom(this.http.post<{ status: string; docs?: IProduct[]; error?: any; }>(environment.baseUrl + '/products', { vendorNos }));
        products = response.docs || [];
      } catch (err: any) {
        console.log(err.message);
      }
    }
    return products;
  }

  private getSessionData(key: string) {
    const data = sessionStorage.getItem(key);
    return data ? JSON.parse(atob(data)) : [];
  }

  private setSessionData(key: string, data: any) {
    if (key && data) {
      sessionStorage.setItem(key, btoa(JSON.stringify(data)));
    }
  }
}

export interface ISupplier {
  _id: string;
  domains: string[];
  logoName: string;
  name: string,
  prmEmail: string;
  scmEmail: string;
  terms: string[];
  type: string;
  vendors: {
    name: string;
    number: string;
  }[];
}

export interface IProduct {
  _id: string;
  productId: number;
  sku: string;
  brand: string;
  name: string;
  price: number;
  msrp: number;
  deleted: boolean;
  published: boolean;
  createdOn: Date;
  isResource: boolean;
  url: string;
  primaryCat: string;
  primaryId: number;
  secondaryCat: string;
  secondaryId: number;
  tertiaryCat: string;
  tertiaryId: number;
  ean: string;
  isPurchasable: boolean;
  reviewCount: number;
  reviewScore: number;
  isEnergyConsumptionGreen: boolean;
  vendorNo: string;
  imageUrl: string;
  views: {
    count: number;
    date: Date;
  }[];
  abandonments: {
    count: number;
    date: Date;
  }[];
  salesOrders: {
    count: number;
    date: Date;
  }[];
}
